import type { CSSProperties, ReactNode } from 'react';

interface GlowCardProps {
  children: ReactNode;
  padded?: boolean;
  elevated?: boolean;
  accent?: 'aurora' | 'none';
  style?: CSSProperties;
  className?: string;
}

/**
 * Surface card.
 * - default: the Figma "card: stat tile" surface (midnight-800 + hairline).
 * - `accent="aurora"`: the Figma "card: glow" surface (midnight gradient fill,
 *   aurora 24% hairline, aurora glow shadow).
 */
export function GlowCard({
  children,
  padded = true,
  elevated = false,
  accent = 'none',
  style,
  className,
}: GlowCardProps): JSX.Element {
  const isAurora = accent === 'aurora';
  const boxShadow = isAurora
    ? 'var(--shadow-glow-card)'
    : elevated
      ? 'var(--shadow-card-deep)'
      : 'var(--shadow-card-soft)';
  return (
    <div
      className={className}
      style={{
        position: 'relative',
        background: isAurora ? 'var(--gradient-midnight)' : 'var(--surface-card)',
        border: `1px solid ${isAurora ? 'rgba(0, 201, 252, 0.24)' : 'var(--hairline)'}`,
        borderRadius: 'var(--radius-2xl)',
        boxShadow,
        padding: padded ? 'var(--space-6)' : 0,
        overflow: 'hidden',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
